

// Returns true if this break is using a "new" layout for the big sponsored flow changes in 2019
export const isNewLayout = (brk) => {
    return brk && brk.layout && brk.layout !== '' && brk.layout !== 'CLASSIC_2018'
    //return true;
};

export const isMultiStepBreak = (brk) => {
  return brk && brk.steps && brk.steps.length > 1;
}



// WEBPACK FOOTER //
// ./public/utils/break-utils.js